import { __rest } from "tslib";
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { SelectAlpha, RadioButton, StackInline, ErrorMessage, StackBlock, Grid, Label } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FormField } from '../FormField';
export const TitleField = ({ fieldName = 'title' }) => {
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.checkout]);
    const { defaultRequestParams, servicesEndpoint, lang } = useAemConfig();
    const { getGenders, getTitles } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: genders = [] } = useQuery(getGenders({ lang }));
    const { data: titlesData } = useQuery(getTitles({ lang }, {
        select: data => ({
            titles: data,
            titleOptions: data.map(title => ({ id: title.id, text: title.title })),
            hasGenderField: Boolean(data.some(title => !title.idGender || title.idGender === '-1')),
        }),
    }));
    const { hasGenderField = false, titles = [], titleOptions = [] } = titlesData || {};
    const { watch, setValue } = useFormContext();
    const titleValue = watch(fieldName);
    useEffect(() => {
        if (!titleValue)
            return;
        const selectedTitle = titles.find(title => title.id === titleValue);
        const selectedGender = genders.find(gender => String(gender.id) === (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.idGender));
        if (selectedGender) {
            setValue('gender', selectedGender.peopleCode);
        }
    }, [titleValue, genders, titles]);
    return (_jsxs(Grid, { columns: 12, gapX: 4, gapY: 6, children: [_jsx(Grid.Cell, { span: { xs: 12, md: 6 }, children: _jsx(FormField, { name: fieldName, required: true, children: (_a) => {
                        var _b = _a.fieldProps, { ref, value, onChange } = _b, options = __rest(_b, ["ref", "value", "onChange"]), { error } = _a;
                        return (_jsx(SelectAlpha, { input: Object.assign(Object.assign({}, options), { id: options.name, label: t(`${I18N_NAMESPACES.account}:account.details.title`), placeholder: t(`${I18N_NAMESPACES.checkout}:checkout.personal.details.title.placeholder`), error, innerRef: ref, required: true }), items: titleOptions, onSelect: value => onChange(value.id), value: titleOptions.length ? value : undefined, testId: options.name }));
                    } }) }), hasGenderField && (_jsx(Grid.Cell, { span: { xs: 12, md: 6 }, children: _jsx(FormField, { name: "gender", required: true, children: (_a) => {
                        var _b = _a.fieldProps, { ref, value } = _b, options = __rest(_b, ["ref", "value"]), { error } = _a;
                        return (_jsxs(StackBlock, { testId: options.name, gap: "2", children: [_jsx(Label, { children: t(`${I18N_NAMESPACES.account}:account.details.gender`) }), _jsx(StackInline, { gap: "2", children: genders.map(({ gender, peopleCode }) => (_createElement(RadioButton, Object.assign({}, options, { id: `field-${peopleCode}`, key: `field-${peopleCode}`, label: gender, value: peopleCode, checked: value === peopleCode })))) }), error && _jsx(ErrorMessage, { children: error })] }));
                    } }) }))] }));
};
